// extracted by mini-css-extract-plugin
module.exports = {"bpk-icon-description":"withDescription_bpk-icon-description__OGVhM","bpk-keyframe-spin":"withDescription_bpk-keyframe-spin__M2E1N"};